import { FormGroup, Validators } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { FormArray } from "@angular/forms";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SkuDetail } from "src/app/models/priceyard.model";
import { filter, takeUntil } from "rxjs/operators";
import { switchMap } from "rxjs/operators";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { map, startWith } from "rxjs/operators";
import { Subject } from "rxjs";
import { SetSkuMapPayload } from "src/app/models/planyard.model";
import { SnackbarComponent } from '../../../../components/snackbar/snackbar.component';
import { MatDialog } from "@angular/material/dialog";
import { CreateItemComponent } from "src/app/components/dialogs/create-item/create-item.component";

@Component({
  selector: "app-sku-mapping-edit",
  templateUrl: "./sku-mapping-edit.component.html",
  styleUrls: ["./sku-mapping-edit.component.scss"],
})
export class SkuMappingEditComponent implements OnInit, OnDestroy {
  formArray: FormArray = new FormArray([]);
  private destroy$ = new Subject<void>();
  @Output() viewEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() title: EventEmitter<boolean> = new EventEmitter();
  @Input() sku: SkuDetail;
  loader: boolean = false;
  @Input() mappings: any;
  fitleredItemsOptions = [];
  startRow = 0;
  amountPerPage = 10;
  startRowArray:any[]=[];

  constructor(
    private planyardService: PlanyardService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.mappings && this.mappings.length != 0) {
      this.mappings.forEach((element, index) => {
        element.name = element.itemName;
        this.formArray.push(
          new FormGroup({
            qty: new FormControl(element.qty, Validators.required),
            item: new FormControl(element, Validators.required),
            hasProduct:new FormControl(false)
          })
        );
        this.addItemsAutocomplete(this.fitleredItemsOptions.length);
      });
    } else this.addMapping();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  addMapping() {
    this.formArray.push(
      new FormGroup({
        qty: new FormControl(1, Validators.required),
        item: new FormControl("", Validators.required),
        hasProduct:new FormControl(false)
      })
    );
    this.addItemsAutocomplete(this.fitleredItemsOptions.length);
  }

  removeMapping(index) {
    this.formArray.removeAt(index);
    this.removeItemsAutocomplete(index);
  }

  addItemsAutocomplete(index: number) {
    this.fitleredItemsOptions.push([]);
    this.formArray
      .at(index)
      .get("item")
      .valueChanges.pipe(
        filter(e => typeof e === 'string'),
        startWith(""),
        takeUntil(this.destroy$),
        map((value) => (value ? value : "")),
        switchMap((value) => {
          if(value){
            this.startRow=0;
            const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_'+index)
            if(idx != -1){
              this.startRowArray['startrow_'+index]=0
            }else{
              this.startRowArray['startrow_'+index] = 0;  
            }
            return this.planyardService.TypeaheadItem(value, null, 'Item',this.startRow,this.startRow + this.amountPerPage)
          } else{
            let e = [];
            return e;
          }
        })
      )
      .subscribe((e: any) => {
        if(e.length == 0){
          this.formArray.controls[index].get('hasProduct').setValue(true);
        } else{
          this.formArray.controls[index].get('hasProduct').setValue(false);
        }
        this.fitleredItemsOptions[index] = e
        this.startRowArray['startrow_'+index]+= this.amountPerPage;
      });
  }

  removeItemsAutocomplete(index: number) {
    this.fitleredItemsOptions.splice(index, 1);
    delete this.startRowArray['startrow_'+index]
  }

  displayFn(item) {
    return item ? item.name : "";
  }

  saveMapping() {
    this.loader = true;
    const payload: SetSkuMapPayload = {
      accountSkuId: this.sku.accountSkuId,
      itemQtys: this.formArray.value.map((item) => {
        return {
          qty: item.qty,
          itemId: item.item.itemId ||  item.item.id,
        };
      }),
    };
    this.planyardService.SetSkuMapping(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
        this.loader = false;
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Mapping updated successfully',
                action: 'Dismiss',
                type: 'success',
              },
            }
        );
        this.cancel();
      },
     error: (err) => {
        this.loader = false;
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Something went wrong',
                action: 'Dismiss',
                type: 'error',
                
              },
            }
        );
      }
   });
  }

  itemTypeahead(itemId, input: ElementRef) {
    this.planyardService
      .TypeaheadItem(itemId.key).pipe(takeUntil(this.destroy$))
      .subscribe((e) => {});
  }

  cancel() {
    this.viewEvent.emit(true);
  }

  createProduct(i){
    this.dialog
      .open(CreateItemComponent, {
        width: "1100px",
        data:{
          isAddProduct:true,
          title:"New Product"
        }
      })
      .afterClosed()
      .pipe(filter((e) => e))
      .subscribe((e) => { 
        let item = {
          itemId:e.itemId,
          name:e.name,
          qty:this.formArray.value[i].qty
        }
        this.formArray.value[i].item = item;  
        this.formArray.controls[i].patchValue({ item : item }, { emitEvent: false });
        this.formArray.controls[i].get('hasProduct').setValue(false);
    });
  }

  registerPanelScrollEvent(element,index) {
    const panel = element;
   panel.addEventListener('scroll', event => this.loadAllOnScroll(event,index));
 }

 setScroll(index){
  const ele= document.querySelectorAll('[id*="mat-autocomplete-"]');
  if(ele.length){
    const id = document.querySelectorAll('[id*="mat-autocomplete-"]')[0].id;
    const element= document.getElementById(id);
    if(element){     
      this.registerPanelScrollEvent(element,index);
    }
  }
  }
  
  loadAllOnScroll(event,index) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_'+index)
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'+index];
      }else{
        this.startRowArray['startrow_'+index] = 0; 
        this.startRow=0;
      }
      this.startRowArray['startrow_'+index]+= this.amountPerPage;
      const value= this.formArray.at(index).get("item").value;
      this.planyardService.TypeaheadItem(value, null, 'Item',this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        this.fitleredItemsOptions[index].push(...res);
      });
    }
  }

}
